module.exports = __webpack_public_path__ + "img/separator6.34776a83.svg";